module.exports = __webpack_public_path__ + "static/media/lousa-1.61ea7740.jpg";